import { ApiErrorBody, containsDomainError } from "#shared/infra/apiError";
import { NestingRunView } from "shared";

import i18n from "./i18n";

const DOMAIN_ERROR_I18N_PREFIX = "domain_errors.";
const NESTING_ERROR_I18N_PREFIX = "nesting_errors.";

export function translateDomainError(
  domainError: NonNullable<ApiErrorBody["domainException"]>,
): string {
  const key = `${DOMAIN_ERROR_I18N_PREFIX}${domainError.code}`;

  return i18n.exists(key)
    ? i18n.t(key, key, (domainError.params ?? {}) as Record<string, unknown>)
    : key;
}

export function translateApiError(body: unknown): string {
  if (containsDomainError(body)) {
    return translateDomainError(body.domainException);
  }

  const key = (body as ApiErrorBody).message;

  return i18n.exists(key) ? i18n.t(key, key) : key;
}

export function translateNestingError(
  nestingRun: Pick<NestingRunView, "errorCode" | "warnings">,
  params: { name?: string } = {},
): string {
  const key = `${NESTING_ERROR_I18N_PREFIX}${nestingRun.errorCode || ""}`;

  return i18n.exists(key)
    ? i18n.t(key, key, {
        name: params.name ?? i18n.t("layout.trueShapeNesting.unknownPart"),
      })
    : nestingRun.warnings.join(" : ");
}
